import { withInstall } from '@element-plus/utils'

import TimeSelect from './src/time-select.vue'

export const ElTimeSelect = withInstall(TimeSelect)
export default ElTimeSelect

export * from './src/time-select'
